//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v14.0.8.0 (NJsonSchema v11.0.1.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming

import moment from 'moment';

export interface IListingSearchClient {

    search(request: SearchRequest): Promise<SearchResultOfBaseSearchModel>;
}

export class ListingSearchClient implements IListingSearchClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    search(request: SearchRequest): Promise<SearchResultOfBaseSearchModel> {
        let url_ = this.baseUrl + "/api/ListingSearch/search";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processSearch(_response);
        });
    }

    protected processSearch(response: Response): Promise<SearchResultOfBaseSearchModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SearchResultOfBaseSearchModel.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SearchResultOfBaseSearchModel>(null as any);
    }
}

export class School implements ISchool {
    id!: string;
    name!: string;
    edi!: boolean;
    address!: string;
    postcode!: string;
    town!: string;
    localAuthority!: string;
    region!: string;
    nation!: string;
    latitude!: number;
    longitude!: number;
    phaseOfEducation!: string;
    independent!: boolean;

    constructor(data?: ISchool) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.name = _data["name"] !== undefined ? _data["name"] : <any>null;
            this.edi = _data["edi"] !== undefined ? _data["edi"] : <any>null;
            this.address = _data["address"] !== undefined ? _data["address"] : <any>null;
            this.postcode = _data["postcode"] !== undefined ? _data["postcode"] : <any>null;
            this.town = _data["town"] !== undefined ? _data["town"] : <any>null;
            this.localAuthority = _data["localAuthority"] !== undefined ? _data["localAuthority"] : <any>null;
            this.region = _data["region"] !== undefined ? _data["region"] : <any>null;
            this.nation = _data["nation"] !== undefined ? _data["nation"] : <any>null;
            this.latitude = _data["latitude"] !== undefined ? _data["latitude"] : <any>null;
            this.longitude = _data["longitude"] !== undefined ? _data["longitude"] : <any>null;
            this.phaseOfEducation = _data["phaseOfEducation"] !== undefined ? _data["phaseOfEducation"] : <any>null;
            this.independent = _data["independent"] !== undefined ? _data["independent"] : <any>null;
        }
    }

    static fromJS(data: any): School {
        data = typeof data === 'object' ? data : {};
        let result = new School();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["name"] = this.name !== undefined ? this.name : <any>null;
        data["edi"] = this.edi !== undefined ? this.edi : <any>null;
        data["address"] = this.address !== undefined ? this.address : <any>null;
        data["postcode"] = this.postcode !== undefined ? this.postcode : <any>null;
        data["town"] = this.town !== undefined ? this.town : <any>null;
        data["localAuthority"] = this.localAuthority !== undefined ? this.localAuthority : <any>null;
        data["region"] = this.region !== undefined ? this.region : <any>null;
        data["nation"] = this.nation !== undefined ? this.nation : <any>null;
        data["latitude"] = this.latitude !== undefined ? this.latitude : <any>null;
        data["longitude"] = this.longitude !== undefined ? this.longitude : <any>null;
        data["phaseOfEducation"] = this.phaseOfEducation !== undefined ? this.phaseOfEducation : <any>null;
        data["independent"] = this.independent !== undefined ? this.independent : <any>null;
        return data;
    }
}

export interface ISchool {
    id: string;
    name: string;
    edi: boolean;
    address: string;
    postcode: string;
    town: string;
    localAuthority: string;
    region: string;
    nation: string;
    latitude: number;
    longitude: number;
    phaseOfEducation: string;
    independent: boolean;
}

export class SearchResultOfBaseSearchModel implements ISearchResultOfBaseSearchModel {
    filters!: Filter[] | null;
    items!: BaseSearchModel[] | null;
    pagination!: Pagination | null;

    constructor(data?: ISearchResultOfBaseSearchModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["filters"])) {
                this.filters = [] as any;
                for (let item of _data["filters"])
                    this.filters!.push(Filter.fromJS(item));
            }
            else {
                this.filters = <any>null;
            }
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(BaseSearchModel.fromJS(item));
            }
            else {
                this.items = <any>null;
            }
            this.pagination = _data["pagination"] ? Pagination.fromJS(_data["pagination"]) : <any>null;
        }
    }

    static fromJS(data: any): SearchResultOfBaseSearchModel {
        data = typeof data === 'object' ? data : {};
        let result = new SearchResultOfBaseSearchModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.filters)) {
            data["filters"] = [];
            for (let item of this.filters)
                data["filters"].push(item.toJSON());
        }
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["pagination"] = this.pagination ? this.pagination.toJSON() : <any>null;
        return data;
    }
}

export interface ISearchResultOfBaseSearchModel {
    filters: Filter[] | null;
    items: BaseSearchModel[] | null;
    pagination: Pagination | null;
}

export class Filter implements IFilter {
    id!: string | null;
    name!: string | null;
    options!: FilterOption[] | null;
    type!: FilterType | null;
    exclusion!: boolean;

    constructor(data?: IFilter) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.name = _data["name"] !== undefined ? _data["name"] : <any>null;
            if (Array.isArray(_data["options"])) {
                this.options = [] as any;
                for (let item of _data["options"])
                    this.options!.push(FilterOption.fromJS(item));
            }
            else {
                this.options = <any>null;
            }
            this.type = _data["type"] !== undefined ? _data["type"] : <any>null;
            this.exclusion = _data["exclusion"] !== undefined ? _data["exclusion"] : <any>null;
        }
    }

    static fromJS(data: any): Filter {
        data = typeof data === 'object' ? data : {};
        let result = new Filter();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["name"] = this.name !== undefined ? this.name : <any>null;
        if (Array.isArray(this.options)) {
            data["options"] = [];
            for (let item of this.options)
                data["options"].push(item.toJSON());
        }
        data["type"] = this.type !== undefined ? this.type : <any>null;
        data["exclusion"] = this.exclusion !== undefined ? this.exclusion : <any>null;
        return data;
    }
}

export interface IFilter {
    id: string | null;
    name: string | null;
    options: FilterOption[] | null;
    type: FilterType | null;
    exclusion: boolean;
}

export class FilterOption implements IFilterOption {
    id!: string | null;
    value!: string | null;
    selected!: boolean;
    name!: string | null;

    constructor(data?: IFilterOption) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.value = _data["value"] !== undefined ? _data["value"] : <any>null;
            this.selected = _data["selected"] !== undefined ? _data["selected"] : <any>null;
            this.name = _data["name"] !== undefined ? _data["name"] : <any>null;
        }
    }

    static fromJS(data: any): FilterOption {
        data = typeof data === 'object' ? data : {};
        let result = new FilterOption();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["value"] = this.value !== undefined ? this.value : <any>null;
        data["selected"] = this.selected !== undefined ? this.selected : <any>null;
        data["name"] = this.name !== undefined ? this.name : <any>null;
        return data;
    }
}

export interface IFilterOption {
    id: string | null;
    value: string | null;
    selected: boolean;
    name: string | null;
}

/** 0 = Date 1 = DateTime 2 = DateRange 3 = LongRange 4 = Spacial 5 = Checkbox 6 = Custom */
export enum FilterType {
    Date = 0,
    DateTime = 1,
    DateRange = 2,
    LongRange = 3,
    Spacial = 4,
    Checkbox = 5,
    Custom = 6,
}

export class BaseSearchModel implements IBaseSearchModel {
    contentType!: string | null;
    description!: string | null;
    id!: number;
    image!: string | null;
    name!: string | null;
    tags!: { [key: string]: BaseSearchTag[]; } | null;
    url!: string | null;

    constructor(data?: IBaseSearchModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.contentType = _data["contentType"] !== undefined ? _data["contentType"] : <any>null;
            this.description = _data["description"] !== undefined ? _data["description"] : <any>null;
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.image = _data["image"] !== undefined ? _data["image"] : <any>null;
            this.name = _data["name"] !== undefined ? _data["name"] : <any>null;
            if (_data["tags"]) {
                this.tags = {} as any;
                for (let key in _data["tags"]) {
                    if (_data["tags"].hasOwnProperty(key))
                        (<any>this.tags)![key] = _data["tags"][key] ? _data["tags"][key].map((i: any) => BaseSearchTag.fromJS(i)) : [];
                }
            }
            else {
                this.tags = <any>null;
            }
            this.url = _data["url"] !== undefined ? _data["url"] : <any>null;
        }
    }

    static fromJS(data: any): BaseSearchModel {
        data = typeof data === 'object' ? data : {};
        let result = new BaseSearchModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["contentType"] = this.contentType !== undefined ? this.contentType : <any>null;
        data["description"] = this.description !== undefined ? this.description : <any>null;
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["image"] = this.image !== undefined ? this.image : <any>null;
        data["name"] = this.name !== undefined ? this.name : <any>null;
        if (this.tags) {
            data["tags"] = {};
            for (let key in this.tags) {
                if (this.tags.hasOwnProperty(key))
                    (<any>data["tags"])[key] = this.tags[key] !== undefined ? this.tags[key] : <any>null;
            }
        }
        data["url"] = this.url !== undefined ? this.url : <any>null;
        return data;
    }
}

export interface IBaseSearchModel {
    contentType: string | null;
    description: string | null;
    id: number;
    image: string | null;
    name: string | null;
    tags: { [key: string]: BaseSearchTag[]; } | null;
    url: string | null;
}

export class BaseSearchTag implements IBaseSearchTag {
    name!: string | null;
    value!: string | null;
    url!: string | null;

    constructor(data?: IBaseSearchTag) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"] !== undefined ? _data["name"] : <any>null;
            this.value = _data["value"] !== undefined ? _data["value"] : <any>null;
            this.url = _data["url"] !== undefined ? _data["url"] : <any>null;
        }
    }

    static fromJS(data: any): BaseSearchTag {
        data = typeof data === 'object' ? data : {};
        let result = new BaseSearchTag();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name !== undefined ? this.name : <any>null;
        data["value"] = this.value !== undefined ? this.value : <any>null;
        data["url"] = this.url !== undefined ? this.url : <any>null;
        return data;
    }
}

export interface IBaseSearchTag {
    name: string | null;
    value: string | null;
    url: string | null;
}

export class Pagination implements IPagination {
    total!: number;
    page!: number;
    pageSize!: number;
    skip!: number;
    totalPages!: number;

    constructor(data?: IPagination) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.total = _data["total"] !== undefined ? _data["total"] : <any>null;
            this.page = _data["page"] !== undefined ? _data["page"] : <any>null;
            this.pageSize = _data["pageSize"] !== undefined ? _data["pageSize"] : <any>null;
            this.skip = _data["skip"] !== undefined ? _data["skip"] : <any>null;
            this.totalPages = _data["totalPages"] !== undefined ? _data["totalPages"] : <any>null;
        }
    }

    static fromJS(data: any): Pagination {
        data = typeof data === 'object' ? data : {};
        let result = new Pagination();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["total"] = this.total !== undefined ? this.total : <any>null;
        data["page"] = this.page !== undefined ? this.page : <any>null;
        data["pageSize"] = this.pageSize !== undefined ? this.pageSize : <any>null;
        data["skip"] = this.skip !== undefined ? this.skip : <any>null;
        data["totalPages"] = this.totalPages !== undefined ? this.totalPages : <any>null;
        return data;
    }
}

export interface IPagination {
    total: number;
    page: number;
    pageSize: number;
    skip: number;
    totalPages: number;
}

export class SearchRequest implements ISearchRequest {
    contentTypes!: string[] | null;
    facets!: string[] | null;
    filters!: Filter[] | null;
    preFilters!: Filter[] | null;
    index!: string;
    listingId!: number;
    page!: number;
    pageSize!: number;
    published!: boolean;
    matchType!: SearchMatchType;
    skip!: number;
    sorts!: { [key: string]: ValueTupleOfSortTypeAndBoolean; };
    term!: string | null;
    culture!: string | null;

    constructor(data?: ISearchRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["contentTypes"])) {
                this.contentTypes = [] as any;
                for (let item of _data["contentTypes"])
                    this.contentTypes!.push(item);
            }
            else {
                this.contentTypes = <any>null;
            }
            if (Array.isArray(_data["facets"])) {
                this.facets = [] as any;
                for (let item of _data["facets"])
                    this.facets!.push(item);
            }
            else {
                this.facets = <any>null;
            }
            if (Array.isArray(_data["filters"])) {
                this.filters = [] as any;
                for (let item of _data["filters"])
                    this.filters!.push(Filter.fromJS(item));
            }
            else {
                this.filters = <any>null;
            }
            if (Array.isArray(_data["preFilters"])) {
                this.preFilters = [] as any;
                for (let item of _data["preFilters"])
                    this.preFilters!.push(Filter.fromJS(item));
            }
            else {
                this.preFilters = <any>null;
            }
            this.index = _data["index"] !== undefined ? _data["index"] : <any>null;
            this.listingId = _data["listingId"] !== undefined ? _data["listingId"] : <any>null;
            this.page = _data["page"] !== undefined ? _data["page"] : <any>null;
            this.pageSize = _data["pageSize"] !== undefined ? _data["pageSize"] : <any>null;
            this.published = _data["published"] !== undefined ? _data["published"] : <any>null;
            this.matchType = _data["matchType"] !== undefined ? _data["matchType"] : <any>null;
            this.skip = _data["skip"] !== undefined ? _data["skip"] : <any>null;
            if (_data["sorts"]) {
                this.sorts = {} as any;
                for (let key in _data["sorts"]) {
                    if (_data["sorts"].hasOwnProperty(key))
                        (<any>this.sorts)![key] = _data["sorts"][key] ? ValueTupleOfSortTypeAndBoolean.fromJS(_data["sorts"][key]) : new ValueTupleOfSortTypeAndBoolean();
                }
            }
            else {
                this.sorts = <any>null;
            }
            this.term = _data["term"] !== undefined ? _data["term"] : <any>null;
            this.culture = _data["culture"] !== undefined ? _data["culture"] : <any>null;
        }
    }

    static fromJS(data: any): SearchRequest {
        data = typeof data === 'object' ? data : {};
        let result = new SearchRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.contentTypes)) {
            data["contentTypes"] = [];
            for (let item of this.contentTypes)
                data["contentTypes"].push(item);
        }
        if (Array.isArray(this.facets)) {
            data["facets"] = [];
            for (let item of this.facets)
                data["facets"].push(item);
        }
        if (Array.isArray(this.filters)) {
            data["filters"] = [];
            for (let item of this.filters)
                data["filters"].push(item.toJSON());
        }
        if (Array.isArray(this.preFilters)) {
            data["preFilters"] = [];
            for (let item of this.preFilters)
                data["preFilters"].push(item.toJSON());
        }
        data["index"] = this.index !== undefined ? this.index : <any>null;
        data["listingId"] = this.listingId !== undefined ? this.listingId : <any>null;
        data["page"] = this.page !== undefined ? this.page : <any>null;
        data["pageSize"] = this.pageSize !== undefined ? this.pageSize : <any>null;
        data["published"] = this.published !== undefined ? this.published : <any>null;
        data["matchType"] = this.matchType !== undefined ? this.matchType : <any>null;
        data["skip"] = this.skip !== undefined ? this.skip : <any>null;
        if (this.sorts) {
            data["sorts"] = {};
            for (let key in this.sorts) {
                if (this.sorts.hasOwnProperty(key))
                    (<any>data["sorts"])[key] = this.sorts[key] ? this.sorts[key].toJSON() : <any>null;
            }
        }
        data["term"] = this.term !== undefined ? this.term : <any>null;
        data["culture"] = this.culture !== undefined ? this.culture : <any>null;
        return data;
    }
}

export interface ISearchRequest {
    contentTypes: string[] | null;
    facets: string[] | null;
    filters: Filter[] | null;
    preFilters: Filter[] | null;
    index: string;
    listingId: number;
    page: number;
    pageSize: number;
    published: boolean;
    matchType: SearchMatchType;
    skip: number;
    sorts: { [key: string]: ValueTupleOfSortTypeAndBoolean; };
    term: string | null;
    culture: string | null;
}

/** 0 = ExactMatchAny 1 = PrefixSearch */
export enum SearchMatchType {
    ExactMatchAny = 0,
    PrefixSearch = 1,
}

export class ValueTupleOfSortTypeAndBoolean implements IValueTupleOfSortTypeAndBoolean {

    constructor(data?: IValueTupleOfSortTypeAndBoolean) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
    }

    static fromJS(data: any): ValueTupleOfSortTypeAndBoolean {
        data = typeof data === 'object' ? data : {};
        let result = new ValueTupleOfSortTypeAndBoolean();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        return data;
    }
}

export interface IValueTupleOfSortTypeAndBoolean {
}

export class ProblemDetails implements IProblemDetails {
    type!: string | null;
    title!: string | null;
    status!: number | null;
    detail!: string | null;
    instance!: string | null;

    [key: string]: any;

    constructor(data?: IProblemDetails) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.type = _data["type"] !== undefined ? _data["type"] : <any>null;
            this.title = _data["title"] !== undefined ? _data["title"] : <any>null;
            this.status = _data["status"] !== undefined ? _data["status"] : <any>null;
            this.detail = _data["detail"] !== undefined ? _data["detail"] : <any>null;
            this.instance = _data["instance"] !== undefined ? _data["instance"] : <any>null;
        }
    }

    static fromJS(data: any): ProblemDetails {
        data = typeof data === 'object' ? data : {};
        let result = new ProblemDetails();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["type"] = this.type !== undefined ? this.type : <any>null;
        data["title"] = this.title !== undefined ? this.title : <any>null;
        data["status"] = this.status !== undefined ? this.status : <any>null;
        data["detail"] = this.detail !== undefined ? this.detail : <any>null;
        data["instance"] = this.instance !== undefined ? this.instance : <any>null;
        return data;
    }
}

export interface IProblemDetails {
    type: string | null;
    title: string | null;
    status: number | null;
    detail: string | null;
    instance: string | null;

    [key: string]: any;
}

/** Defines a form entry submitted to the headless/AJAX API. */
export class FormEntryDto implements IFormEntryDto {
    /** Gets or sets the form entry's values. */
    values!: { [key: string]: string[]; };
    /** Gets or sets an optional ID of the content page through which the form was submitted. */
    contentId!: string | null;
    /** Gets or sets an optional culture code for which the form submission should be processed. */
    culture!: string | null;
    /** Gets or sets optional additional data that will be made available to workflows. */
    additionalData!: { [key: string]: string; } | null;

    constructor(data?: IFormEntryDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (_data["values"]) {
                this.values = {} as any;
                for (let key in _data["values"]) {
                    if (_data["values"].hasOwnProperty(key))
                        (<any>this.values)![key] = _data["values"][key] !== undefined ? _data["values"][key] : [];
                }
            }
            else {
                this.values = <any>null;
            }
            this.contentId = _data["contentId"] !== undefined ? _data["contentId"] : <any>null;
            this.culture = _data["culture"] !== undefined ? _data["culture"] : <any>null;
            if (_data["additionalData"]) {
                this.additionalData = {} as any;
                for (let key in _data["additionalData"]) {
                    if (_data["additionalData"].hasOwnProperty(key))
                        (<any>this.additionalData)![key] = _data["additionalData"][key] !== undefined ? _data["additionalData"][key] : <any>null;
                }
            }
            else {
                this.additionalData = <any>null;
            }
        }
    }

    static fromJS(data: any): FormEntryDto {
        data = typeof data === 'object' ? data : {};
        let result = new FormEntryDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.values) {
            data["values"] = {};
            for (let key in this.values) {
                if (this.values.hasOwnProperty(key))
                    (<any>data["values"])[key] = this.values[key] !== undefined ? this.values[key] : <any>null;
            }
        }
        data["contentId"] = this.contentId !== undefined ? this.contentId : <any>null;
        data["culture"] = this.culture !== undefined ? this.culture : <any>null;
        if (this.additionalData) {
            data["additionalData"] = {};
            for (let key in this.additionalData) {
                if (this.additionalData.hasOwnProperty(key))
                    (<any>data["additionalData"])[key] = this.additionalData[key] !== undefined ? this.additionalData[key] : <any>null;
            }
        }
        return data;
    }
}

/** Defines a form entry submitted to the headless/AJAX API. */
export interface IFormEntryDto {
    /** Gets or sets the form entry's values. */
    values: { [key: string]: string[]; };
    /** Gets or sets an optional ID of the content page through which the form was submitted. */
    contentId: string | null;
    /** Gets or sets an optional culture code for which the form submission should be processed. */
    culture: string | null;
    /** Gets or sets optional additional data that will be made available to workflows. */
    additionalData: { [key: string]: string; } | null;
}

/** Defines a form object exposed by the headless/AJAX API. */
export class FormDto implements IFormDto {
    /** Gets or sets the form's ID. */
    id!: string;
    /** Gets or sets the form's name. */
    name!: string;
    /** Gets or sets the form's indicator for mandatory fields. */
    indicator!: string;
    /** Gets or sets the form's CSS class. */
    cssClass!: string | null;
    /** Gets or sets the form's label for the next page button. */
    nextLabel!: string | null;
    /** Gets or sets the form's label for the previous page button. */
    previousLabel!: string | null;
    /** Gets or sets the form's button submit label. */
    submitLabel!: string | null;
    /** Gets or sets a value indicating whether to disable the form's default stylesheet. */
    disableDefaultStylesheet!: boolean;
    /** Gets or sets the form's field mandatory or optional field indication type. */
    fieldIndicationType!: FormFieldIndication;
    /** Gets or sets a value indicating whether to hide field validation. */
    hideFieldValidation!: boolean;
    /** Gets or sets the form's message to display on submission. */
    messageOnSubmit!: string | null;
    /** Gets or sets a value indicating whether the form's message to display on submission is in HTML format. */
    messageOnSubmitIsHtml!: boolean;
    /** Gets or sets a value indicating whether to show the form's validation summary. */
    showValidationSummary!: boolean;
    /** Gets or sets the form's page to redirect to following submission as an Id. */
    gotoPageOnSubmit!: string | null;
    /** Gets or sets the form's page to redirect to following submission as a route. */
    gotoPageOnSubmitRoute!: IApiContentRoute | null;
    /** Gets or sets the form's pages. */
    pages!: FormPageDto[];

    constructor(data?: IFormDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.name = _data["name"] !== undefined ? _data["name"] : <any>null;
            this.indicator = _data["indicator"] !== undefined ? _data["indicator"] : <any>null;
            this.cssClass = _data["cssClass"] !== undefined ? _data["cssClass"] : <any>null;
            this.nextLabel = _data["nextLabel"] !== undefined ? _data["nextLabel"] : <any>null;
            this.previousLabel = _data["previousLabel"] !== undefined ? _data["previousLabel"] : <any>null;
            this.submitLabel = _data["submitLabel"] !== undefined ? _data["submitLabel"] : <any>null;
            this.disableDefaultStylesheet = _data["disableDefaultStylesheet"] !== undefined ? _data["disableDefaultStylesheet"] : <any>null;
            this.fieldIndicationType = _data["fieldIndicationType"] !== undefined ? _data["fieldIndicationType"] : <any>null;
            this.hideFieldValidation = _data["hideFieldValidation"] !== undefined ? _data["hideFieldValidation"] : <any>null;
            this.messageOnSubmit = _data["messageOnSubmit"] !== undefined ? _data["messageOnSubmit"] : <any>null;
            this.messageOnSubmitIsHtml = _data["messageOnSubmitIsHtml"] !== undefined ? _data["messageOnSubmitIsHtml"] : <any>null;
            this.showValidationSummary = _data["showValidationSummary"] !== undefined ? _data["showValidationSummary"] : <any>null;
            this.gotoPageOnSubmit = _data["gotoPageOnSubmit"] !== undefined ? _data["gotoPageOnSubmit"] : <any>null;
            this.gotoPageOnSubmitRoute = _data["gotoPageOnSubmitRoute"] ? IApiContentRoute.fromJS(_data["gotoPageOnSubmitRoute"]) : <any>null;
            if (Array.isArray(_data["pages"])) {
                this.pages = [] as any;
                for (let item of _data["pages"])
                    this.pages!.push(FormPageDto.fromJS(item));
            }
            else {
                this.pages = <any>null;
            }
        }
    }

    static fromJS(data: any): FormDto {
        data = typeof data === 'object' ? data : {};
        let result = new FormDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["name"] = this.name !== undefined ? this.name : <any>null;
        data["indicator"] = this.indicator !== undefined ? this.indicator : <any>null;
        data["cssClass"] = this.cssClass !== undefined ? this.cssClass : <any>null;
        data["nextLabel"] = this.nextLabel !== undefined ? this.nextLabel : <any>null;
        data["previousLabel"] = this.previousLabel !== undefined ? this.previousLabel : <any>null;
        data["submitLabel"] = this.submitLabel !== undefined ? this.submitLabel : <any>null;
        data["disableDefaultStylesheet"] = this.disableDefaultStylesheet !== undefined ? this.disableDefaultStylesheet : <any>null;
        data["fieldIndicationType"] = this.fieldIndicationType !== undefined ? this.fieldIndicationType : <any>null;
        data["hideFieldValidation"] = this.hideFieldValidation !== undefined ? this.hideFieldValidation : <any>null;
        data["messageOnSubmit"] = this.messageOnSubmit !== undefined ? this.messageOnSubmit : <any>null;
        data["messageOnSubmitIsHtml"] = this.messageOnSubmitIsHtml !== undefined ? this.messageOnSubmitIsHtml : <any>null;
        data["showValidationSummary"] = this.showValidationSummary !== undefined ? this.showValidationSummary : <any>null;
        data["gotoPageOnSubmit"] = this.gotoPageOnSubmit !== undefined ? this.gotoPageOnSubmit : <any>null;
        data["gotoPageOnSubmitRoute"] = this.gotoPageOnSubmitRoute ? this.gotoPageOnSubmitRoute.toJSON() : <any>null;
        if (Array.isArray(this.pages)) {
            data["pages"] = [];
            for (let item of this.pages)
                data["pages"].push(item.toJSON());
        }
        return data;
    }
}

/** Defines a form object exposed by the headless/AJAX API. */
export interface IFormDto {
    /** Gets or sets the form's ID. */
    id: string;
    /** Gets or sets the form's name. */
    name: string;
    /** Gets or sets the form's indicator for mandatory fields. */
    indicator: string;
    /** Gets or sets the form's CSS class. */
    cssClass: string | null;
    /** Gets or sets the form's label for the next page button. */
    nextLabel: string | null;
    /** Gets or sets the form's label for the previous page button. */
    previousLabel: string | null;
    /** Gets or sets the form's button submit label. */
    submitLabel: string | null;
    /** Gets or sets a value indicating whether to disable the form's default stylesheet. */
    disableDefaultStylesheet: boolean;
    /** Gets or sets the form's field mandatory or optional field indication type. */
    fieldIndicationType: FormFieldIndication;
    /** Gets or sets a value indicating whether to hide field validation. */
    hideFieldValidation: boolean;
    /** Gets or sets the form's message to display on submission. */
    messageOnSubmit: string | null;
    /** Gets or sets a value indicating whether the form's message to display on submission is in HTML format. */
    messageOnSubmitIsHtml: boolean;
    /** Gets or sets a value indicating whether to show the form's validation summary. */
    showValidationSummary: boolean;
    /** Gets or sets the form's page to redirect to following submission as an Id. */
    gotoPageOnSubmit: string | null;
    /** Gets or sets the form's page to redirect to following submission as a route. */
    gotoPageOnSubmitRoute: IApiContentRoute | null;
    /** Gets or sets the form's pages. */
    pages: FormPageDto[];
}

/** Enumeration for field indications. 0 = NoIndicator 1 = MarkMandatoryFields 2 = MarkOptionalFields */
export enum FormFieldIndication {
    NoIndicator = 0,
    MarkMandatoryFields = 1,
    MarkOptionalFields = 2,
}

export abstract class IApiContentRoute implements IIApiContentRoute {
    path!: string;
    startItem!: IApiContentStartItem;

    constructor(data?: IIApiContentRoute) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.path = _data["path"] !== undefined ? _data["path"] : <any>null;
            this.startItem = _data["startItem"] ? IApiContentStartItem.fromJS(_data["startItem"]) : <any>null;
        }
    }

    static fromJS(data: any): IApiContentRoute {
        data = typeof data === 'object' ? data : {};
        throw new Error("The abstract class 'IApiContentRoute' cannot be instantiated.");
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["path"] = this.path !== undefined ? this.path : <any>null;
        data["startItem"] = this.startItem ? this.startItem.toJSON() : <any>null;
        return data;
    }
}

export interface IIApiContentRoute {
    path: string;
    startItem: IApiContentStartItem;
}

export abstract class IApiContentStartItem implements IIApiContentStartItem {
    id!: string;
    path!: string;

    constructor(data?: IIApiContentStartItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.path = _data["path"] !== undefined ? _data["path"] : <any>null;
        }
    }

    static fromJS(data: any): IApiContentStartItem {
        data = typeof data === 'object' ? data : {};
        throw new Error("The abstract class 'IApiContentStartItem' cannot be instantiated.");
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["path"] = this.path !== undefined ? this.path : <any>null;
        return data;
    }
}

export interface IIApiContentStartItem {
    id: string;
    path: string;
}

/** Defines a form's page object exposed by the headless/AJAX API. */
export class FormPageDto implements IFormPageDto {
    /** Gets or sets the form page's caption. */
    caption!: string | null;
    /** Gets or sets the form page's condition. */
    condition!: FormConditionDto | null;
    /** Gets or sets the form page's fieldsets. */
    fieldsets!: FormFieldsetDto[];

    constructor(data?: IFormPageDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.caption = _data["caption"] !== undefined ? _data["caption"] : <any>null;
            this.condition = _data["condition"] ? FormConditionDto.fromJS(_data["condition"]) : <any>null;
            if (Array.isArray(_data["fieldsets"])) {
                this.fieldsets = [] as any;
                for (let item of _data["fieldsets"])
                    this.fieldsets!.push(FormFieldsetDto.fromJS(item));
            }
            else {
                this.fieldsets = <any>null;
            }
        }
    }

    static fromJS(data: any): FormPageDto {
        data = typeof data === 'object' ? data : {};
        let result = new FormPageDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["caption"] = this.caption !== undefined ? this.caption : <any>null;
        data["condition"] = this.condition ? this.condition.toJSON() : <any>null;
        if (Array.isArray(this.fieldsets)) {
            data["fieldsets"] = [];
            for (let item of this.fieldsets)
                data["fieldsets"].push(item.toJSON());
        }
        return data;
    }
}

/** Defines a form's page object exposed by the headless/AJAX API. */
export interface IFormPageDto {
    /** Gets or sets the form page's caption. */
    caption: string | null;
    /** Gets or sets the form page's condition. */
    condition: FormConditionDto | null;
    /** Gets or sets the form page's fieldsets. */
    fieldsets: FormFieldsetDto[];
}

/** Defines a form's condition object exposed by the headless/AJAX API. */
export class FormConditionDto implements IFormConditionDto {
    /** Gets or sets the form condition's action type. */
    actionType!: FieldConditionActionType;
    /** Gets or sets the form condition's logic type. */
    logicType!: FieldConditionLogicType;
    /** Gets or sets the form condition's rules. */
    rules!: FormConditionRuleDto[];

    constructor(data?: IFormConditionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.actionType = _data["actionType"] !== undefined ? _data["actionType"] : <any>null;
            this.logicType = _data["logicType"] !== undefined ? _data["logicType"] : <any>null;
            if (Array.isArray(_data["rules"])) {
                this.rules = [] as any;
                for (let item of _data["rules"])
                    this.rules!.push(FormConditionRuleDto.fromJS(item));
            }
            else {
                this.rules = <any>null;
            }
        }
    }

    static fromJS(data: any): FormConditionDto {
        data = typeof data === 'object' ? data : {};
        let result = new FormConditionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["actionType"] = this.actionType !== undefined ? this.actionType : <any>null;
        data["logicType"] = this.logicType !== undefined ? this.logicType : <any>null;
        if (Array.isArray(this.rules)) {
            data["rules"] = [];
            for (let item of this.rules)
                data["rules"].push(item.toJSON());
        }
        return data;
    }
}

/** Defines a form's condition object exposed by the headless/AJAX API. */
export interface IFormConditionDto {
    /** Gets or sets the form condition's action type. */
    actionType: FieldConditionActionType;
    /** Gets or sets the form condition's logic type. */
    logicType: FieldConditionLogicType;
    /** Gets or sets the form condition's rules. */
    rules: FormConditionRuleDto[];
}

/** Enumeration for field condition display options. 0 = Show 1 = Hide */
export enum FieldConditionActionType {
    Show = 0,
    Hide = 1,
}

/** Enumeration for field condition logic matches. 0 = All 1 = Any */
export enum FieldConditionLogicType {
    All = 0,
    Any = 1,
}

/** Defines a form condition's rule object exposed by the headless/AJAX API. */
export class FormConditionRuleDto implements IFormConditionRuleDto {
    /** Gets or sets fhe form condition rules's field. */
    field!: string;
    /** Gets or sets fhe form condition rules's operator. */
    operator!: FieldConditionRuleOperator;
    /** Gets or sets fhe form condition rules's value. */
    value!: string;

    constructor(data?: IFormConditionRuleDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.field = _data["field"] !== undefined ? _data["field"] : <any>null;
            this.operator = _data["operator"] !== undefined ? _data["operator"] : <any>null;
            this.value = _data["value"] !== undefined ? _data["value"] : <any>null;
        }
    }

    static fromJS(data: any): FormConditionRuleDto {
        data = typeof data === 'object' ? data : {};
        let result = new FormConditionRuleDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["field"] = this.field !== undefined ? this.field : <any>null;
        data["operator"] = this.operator !== undefined ? this.operator : <any>null;
        data["value"] = this.value !== undefined ? this.value : <any>null;
        return data;
    }
}

/** Defines a form condition's rule object exposed by the headless/AJAX API. */
export interface IFormConditionRuleDto {
    /** Gets or sets fhe form condition rules's field. */
    field: string;
    /** Gets or sets fhe form condition rules's operator. */
    operator: FieldConditionRuleOperator;
    /** Gets or sets fhe form condition rules's value. */
    value: string;
}

/** Enumeration for field condition rule operators. 0 = Is 1 = IsNot 2 = GreaterThen 3 = LessThen 4 = Contains 5 = ContainsIgnoreCase 6 = StartsWith 7 = StartsWithIgnoreCase 8 = EndsWith 9 = EndsWithIgnoreCase 10 = NotContains 11 = NotContainsIgnoreCase 12 = NotStartsWith 13 = NotStartsWithIgnoreCase 14 = NotEndsWith 15 = NotEndsWithIgnoreCase */
export enum FieldConditionRuleOperator {
    Is = 0,
    IsNot = 1,
    GreaterThen = 2,
    LessThen = 3,
    Contains = 4,
    ContainsIgnoreCase = 5,
    StartsWith = 6,
    StartsWithIgnoreCase = 7,
    EndsWith = 8,
    EndsWithIgnoreCase = 9,
    NotContains = 10,
    NotContainsIgnoreCase = 11,
    NotStartsWith = 12,
    NotStartsWithIgnoreCase = 13,
    NotEndsWith = 14,
    NotEndsWithIgnoreCase = 15,
}

/** Defines a form's fieldset object exposed by the headless/AJAX API. */
export class FormFieldsetDto implements IFormFieldsetDto {
    /** Gets or sets the form fieldset's ID. */
    id!: string;
    /** Gets or sets the form fieldset's caption. */
    caption!: string | null;
    /** Gets or sets the form fieldset's condition. */
    condition!: FormConditionDto | null;
    /** Gets or sets the form fieldset's columns. */
    columns!: FormFieldsetColumnDto[];

    constructor(data?: IFormFieldsetDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.caption = _data["caption"] !== undefined ? _data["caption"] : <any>null;
            this.condition = _data["condition"] ? FormConditionDto.fromJS(_data["condition"]) : <any>null;
            if (Array.isArray(_data["columns"])) {
                this.columns = [] as any;
                for (let item of _data["columns"])
                    this.columns!.push(FormFieldsetColumnDto.fromJS(item));
            }
            else {
                this.columns = <any>null;
            }
        }
    }

    static fromJS(data: any): FormFieldsetDto {
        data = typeof data === 'object' ? data : {};
        let result = new FormFieldsetDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["caption"] = this.caption !== undefined ? this.caption : <any>null;
        data["condition"] = this.condition ? this.condition.toJSON() : <any>null;
        if (Array.isArray(this.columns)) {
            data["columns"] = [];
            for (let item of this.columns)
                data["columns"].push(item.toJSON());
        }
        return data;
    }
}

/** Defines a form's fieldset object exposed by the headless/AJAX API. */
export interface IFormFieldsetDto {
    /** Gets or sets the form fieldset's ID. */
    id: string;
    /** Gets or sets the form fieldset's caption. */
    caption: string | null;
    /** Gets or sets the form fieldset's condition. */
    condition: FormConditionDto | null;
    /** Gets or sets the form fieldset's columns. */
    columns: FormFieldsetColumnDto[];
}

/** Defines a form fieldset's column (or container) object exposed by the headless/AJAX API. */
export class FormFieldsetColumnDto implements IFormFieldsetColumnDto {
    /** Gets or sets the form fieldset column's caption. */
    caption!: string | null;
    /** Gets or sets the form fieldset column's width. */
    width!: number;
    /** Gets or sets the form fieldset column's fields. */
    fields!: FormFieldDto[];

    constructor(data?: IFormFieldsetColumnDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.caption = _data["caption"] !== undefined ? _data["caption"] : <any>null;
            this.width = _data["width"] !== undefined ? _data["width"] : <any>null;
            if (Array.isArray(_data["fields"])) {
                this.fields = [] as any;
                for (let item of _data["fields"])
                    this.fields!.push(FormFieldDto.fromJS(item));
            }
            else {
                this.fields = <any>null;
            }
        }
    }

    static fromJS(data: any): FormFieldsetColumnDto {
        data = typeof data === 'object' ? data : {};
        let result = new FormFieldsetColumnDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["caption"] = this.caption !== undefined ? this.caption : <any>null;
        data["width"] = this.width !== undefined ? this.width : <any>null;
        if (Array.isArray(this.fields)) {
            data["fields"] = [];
            for (let item of this.fields)
                data["fields"].push(item.toJSON());
        }
        return data;
    }
}

/** Defines a form fieldset's column (or container) object exposed by the headless/AJAX API. */
export interface IFormFieldsetColumnDto {
    /** Gets or sets the form fieldset column's caption. */
    caption: string | null;
    /** Gets or sets the form fieldset column's width. */
    width: number;
    /** Gets or sets the form fieldset column's fields. */
    fields: FormFieldDto[];
}

/** Defines a form's field object exposed by the headless/AJAX API. */
export class FormFieldDto implements IFormFieldDto {
    /** Gets or sets the form field's ID. */
    id!: string;
    /** Gets or sets the form field's catpion. */
    caption!: string;
    /** Gets or sets the form field's help text. */
    helpText!: string | null;
    /** Gets or sets the form field's placeholder. */
    placeholder!: string | null;
    /** Gets or sets the form field's CSS class. */
    cssClass!: string | null;
    /** Gets or sets the form field's alias. */
    alias!: string;
    /** Gets or sets a value indicating whether the form field is required to be completed. */
    required!: boolean;
    /** Gets or sets the form field's message to display if the required field is not completed. */
    requiredErrorMessage!: string | null;
    /** Gets or sets the form field's validation pattern (regular expression). */
    pattern!: string | null;
    /** Gets or sets the form field's message to display if the field does not match the provided pattern. */
    patternInvalidErrorMessage!: string | null;
    /** Gets or sets the form field's condition. */
    condition!: FormConditionDto | null;
    /** Gets or sets the form field's file upload options. */
    fileUploadOptions!: FormFileUploadOptionsDto | null;
    /** Gets or sets the form field's prevalues. */
    preValues!: FormFieldPrevalueDto[];
    /** Gets or sets the form field's settings. */
    settings!: { [key: string]: string; };
    /** Gets or sets the form field's type. */
    type!: FormFieldTypeDto;

    constructor(data?: IFormFieldDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.caption = _data["caption"] !== undefined ? _data["caption"] : <any>null;
            this.helpText = _data["helpText"] !== undefined ? _data["helpText"] : <any>null;
            this.placeholder = _data["placeholder"] !== undefined ? _data["placeholder"] : <any>null;
            this.cssClass = _data["cssClass"] !== undefined ? _data["cssClass"] : <any>null;
            this.alias = _data["alias"] !== undefined ? _data["alias"] : <any>null;
            this.required = _data["required"] !== undefined ? _data["required"] : <any>null;
            this.requiredErrorMessage = _data["requiredErrorMessage"] !== undefined ? _data["requiredErrorMessage"] : <any>null;
            this.pattern = _data["pattern"] !== undefined ? _data["pattern"] : <any>null;
            this.patternInvalidErrorMessage = _data["patternInvalidErrorMessage"] !== undefined ? _data["patternInvalidErrorMessage"] : <any>null;
            this.condition = _data["condition"] ? FormConditionDto.fromJS(_data["condition"]) : <any>null;
            this.fileUploadOptions = _data["fileUploadOptions"] ? FormFileUploadOptionsDto.fromJS(_data["fileUploadOptions"]) : <any>null;
            if (Array.isArray(_data["preValues"])) {
                this.preValues = [] as any;
                for (let item of _data["preValues"])
                    this.preValues!.push(FormFieldPrevalueDto.fromJS(item));
            }
            else {
                this.preValues = <any>null;
            }
            if (_data["settings"]) {
                this.settings = {} as any;
                for (let key in _data["settings"]) {
                    if (_data["settings"].hasOwnProperty(key))
                        (<any>this.settings)![key] = _data["settings"][key] !== undefined ? _data["settings"][key] : <any>null;
                }
            }
            else {
                this.settings = <any>null;
            }
            this.type = _data["type"] ? FormFieldTypeDto.fromJS(_data["type"]) : <any>null;
        }
    }

    static fromJS(data: any): FormFieldDto {
        data = typeof data === 'object' ? data : {};
        let result = new FormFieldDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["caption"] = this.caption !== undefined ? this.caption : <any>null;
        data["helpText"] = this.helpText !== undefined ? this.helpText : <any>null;
        data["placeholder"] = this.placeholder !== undefined ? this.placeholder : <any>null;
        data["cssClass"] = this.cssClass !== undefined ? this.cssClass : <any>null;
        data["alias"] = this.alias !== undefined ? this.alias : <any>null;
        data["required"] = this.required !== undefined ? this.required : <any>null;
        data["requiredErrorMessage"] = this.requiredErrorMessage !== undefined ? this.requiredErrorMessage : <any>null;
        data["pattern"] = this.pattern !== undefined ? this.pattern : <any>null;
        data["patternInvalidErrorMessage"] = this.patternInvalidErrorMessage !== undefined ? this.patternInvalidErrorMessage : <any>null;
        data["condition"] = this.condition ? this.condition.toJSON() : <any>null;
        data["fileUploadOptions"] = this.fileUploadOptions ? this.fileUploadOptions.toJSON() : <any>null;
        if (Array.isArray(this.preValues)) {
            data["preValues"] = [];
            for (let item of this.preValues)
                data["preValues"].push(item.toJSON());
        }
        if (this.settings) {
            data["settings"] = {};
            for (let key in this.settings) {
                if (this.settings.hasOwnProperty(key))
                    (<any>data["settings"])[key] = this.settings[key] !== undefined ? this.settings[key] : <any>null;
            }
        }
        data["type"] = this.type ? this.type.toJSON() : <any>null;
        return data;
    }
}

/** Defines a form's field object exposed by the headless/AJAX API. */
export interface IFormFieldDto {
    /** Gets or sets the form field's ID. */
    id: string;
    /** Gets or sets the form field's catpion. */
    caption: string;
    /** Gets or sets the form field's help text. */
    helpText: string | null;
    /** Gets or sets the form field's placeholder. */
    placeholder: string | null;
    /** Gets or sets the form field's CSS class. */
    cssClass: string | null;
    /** Gets or sets the form field's alias. */
    alias: string;
    /** Gets or sets a value indicating whether the form field is required to be completed. */
    required: boolean;
    /** Gets or sets the form field's message to display if the required field is not completed. */
    requiredErrorMessage: string | null;
    /** Gets or sets the form field's validation pattern (regular expression). */
    pattern: string | null;
    /** Gets or sets the form field's message to display if the field does not match the provided pattern. */
    patternInvalidErrorMessage: string | null;
    /** Gets or sets the form field's condition. */
    condition: FormConditionDto | null;
    /** Gets or sets the form field's file upload options. */
    fileUploadOptions: FormFileUploadOptionsDto | null;
    /** Gets or sets the form field's prevalues. */
    preValues: FormFieldPrevalueDto[];
    /** Gets or sets the form field's settings. */
    settings: { [key: string]: string; };
    /** Gets or sets the form field's type. */
    type: FormFieldTypeDto;
}

/** Defines a form's file upload options object exposed by the headless/AJAX API. */
export class FormFileUploadOptionsDto implements IFormFileUploadOptionsDto {
    /** Gets or sets a value indicating whether all file extensions are allowed. */
    allowAllUploadExtensions!: boolean;
    /** Gets or sets the allowed file extensions. */
    allowedUploadExtensions!: string[];
    /** Gets or sets a value indicating whether multiple file uploads are allowed. */
    allowMultipleFileUploads!: boolean;

    constructor(data?: IFormFileUploadOptionsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.allowAllUploadExtensions = _data["allowAllUploadExtensions"] !== undefined ? _data["allowAllUploadExtensions"] : <any>null;
            if (Array.isArray(_data["allowedUploadExtensions"])) {
                this.allowedUploadExtensions = [] as any;
                for (let item of _data["allowedUploadExtensions"])
                    this.allowedUploadExtensions!.push(item);
            }
            else {
                this.allowedUploadExtensions = <any>null;
            }
            this.allowMultipleFileUploads = _data["allowMultipleFileUploads"] !== undefined ? _data["allowMultipleFileUploads"] : <any>null;
        }
    }

    static fromJS(data: any): FormFileUploadOptionsDto {
        data = typeof data === 'object' ? data : {};
        let result = new FormFileUploadOptionsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["allowAllUploadExtensions"] = this.allowAllUploadExtensions !== undefined ? this.allowAllUploadExtensions : <any>null;
        if (Array.isArray(this.allowedUploadExtensions)) {
            data["allowedUploadExtensions"] = [];
            for (let item of this.allowedUploadExtensions)
                data["allowedUploadExtensions"].push(item);
        }
        data["allowMultipleFileUploads"] = this.allowMultipleFileUploads !== undefined ? this.allowMultipleFileUploads : <any>null;
        return data;
    }
}

/** Defines a form's file upload options object exposed by the headless/AJAX API. */
export interface IFormFileUploadOptionsDto {
    /** Gets or sets a value indicating whether all file extensions are allowed. */
    allowAllUploadExtensions: boolean;
    /** Gets or sets the allowed file extensions. */
    allowedUploadExtensions: string[];
    /** Gets or sets a value indicating whether multiple file uploads are allowed. */
    allowMultipleFileUploads: boolean;
}

/** Defines a form field's prevalue object exposed by the headless/AJAX API. */
export class FormFieldPrevalueDto implements IFormFieldPrevalueDto {
    /** Gets or sets the form field prevalue's value. */
    value!: string;
    /** Gets or sets the form field prevalue's caption. */
    caption!: string | null;

    constructor(data?: IFormFieldPrevalueDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.value = _data["value"] !== undefined ? _data["value"] : <any>null;
            this.caption = _data["caption"] !== undefined ? _data["caption"] : <any>null;
        }
    }

    static fromJS(data: any): FormFieldPrevalueDto {
        data = typeof data === 'object' ? data : {};
        let result = new FormFieldPrevalueDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["value"] = this.value !== undefined ? this.value : <any>null;
        data["caption"] = this.caption !== undefined ? this.caption : <any>null;
        return data;
    }
}

/** Defines a form field's prevalue object exposed by the headless/AJAX API. */
export interface IFormFieldPrevalueDto {
    /** Gets or sets the form field prevalue's value. */
    value: string;
    /** Gets or sets the form field prevalue's caption. */
    caption: string | null;
}

/** Defines a form's field type object exposed by the headless/AJAX API. */
export class FormFieldTypeDto implements IFormFieldTypeDto {
    /** Gets or sets the form type's ID. */
    id!: string;
    /** Gets or sets the form type's name. */
    name!: string;
    /** Gets or sets a value indicating whether the form type's supports prevalues. */
    supportsPreValues!: boolean;
    /** Gets or sets a value indicating whether the form type's supports file uploads. */
    supportsUploadTypes!: boolean;
    /** Gets or sets a value indicating how the the field should be rendered, as a single input, multiple inputs within an an HTML fieldset (e.g. a radio button or check box list). */
    renderInputType!: string;

    constructor(data?: IFormFieldTypeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.name = _data["name"] !== undefined ? _data["name"] : <any>null;
            this.supportsPreValues = _data["supportsPreValues"] !== undefined ? _data["supportsPreValues"] : <any>null;
            this.supportsUploadTypes = _data["supportsUploadTypes"] !== undefined ? _data["supportsUploadTypes"] : <any>null;
            this.renderInputType = _data["renderInputType"] !== undefined ? _data["renderInputType"] : <any>null;
        }
    }

    static fromJS(data: any): FormFieldTypeDto {
        data = typeof data === 'object' ? data : {};
        let result = new FormFieldTypeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["name"] = this.name !== undefined ? this.name : <any>null;
        data["supportsPreValues"] = this.supportsPreValues !== undefined ? this.supportsPreValues : <any>null;
        data["supportsUploadTypes"] = this.supportsUploadTypes !== undefined ? this.supportsUploadTypes : <any>null;
        data["renderInputType"] = this.renderInputType !== undefined ? this.renderInputType : <any>null;
        return data;
    }
}

/** Defines a form's field type object exposed by the headless/AJAX API. */
export interface IFormFieldTypeDto {
    /** Gets or sets the form type's ID. */
    id: string;
    /** Gets or sets the form type's name. */
    name: string;
    /** Gets or sets a value indicating whether the form type's supports prevalues. */
    supportsPreValues: boolean;
    /** Gets or sets a value indicating whether the form type's supports file uploads. */
    supportsUploadTypes: boolean;
    /** Gets or sets a value indicating how the the field should be rendered, as a single input, multiple inputs within an an HTML fieldset (e.g. a radio button or check box list). */
    renderInputType: string;
}

export abstract class IApiMediaWithCropsResponse implements IIApiMediaWithCropsResponse {
    path!: string;
    createDate!: moment.Moment;
    updateDate!: moment.Moment;

    constructor(data?: IIApiMediaWithCropsResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.path = _data["path"] !== undefined ? _data["path"] : <any>null;
            this.createDate = _data["createDate"] ? moment.parseZone(_data["createDate"].toString()) : <any>null;
            this.updateDate = _data["updateDate"] ? moment.parseZone(_data["updateDate"].toString()) : <any>null;
        }
    }

    static fromJS(data: any): IApiMediaWithCropsResponse {
        data = typeof data === 'object' ? data : {};
        throw new Error("The abstract class 'IApiMediaWithCropsResponse' cannot be instantiated.");
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["path"] = this.path !== undefined ? this.path : <any>null;
        data["createDate"] = this.createDate ? this.createDate.toISOString(true) : <any>null;
        data["updateDate"] = this.updateDate ? this.updateDate.toISOString(true) : <any>null;
        return data;
    }
}

export interface IIApiMediaWithCropsResponse {
    path: string;
    createDate: moment.Moment;
    updateDate: moment.Moment;
}

export class PagedViewModelOfIApiMediaWithCropsResponse implements IPagedViewModelOfIApiMediaWithCropsResponse {
    total!: number;
    items!: IApiMediaWithCropsResponse[];

    constructor(data?: IPagedViewModelOfIApiMediaWithCropsResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.items = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.total = _data["total"] !== undefined ? _data["total"] : <any>null;
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(IApiMediaWithCropsResponse.fromJS(item));
            }
            else {
                this.items = <any>null;
            }
        }
    }

    static fromJS(data: any): PagedViewModelOfIApiMediaWithCropsResponse {
        data = typeof data === 'object' ? data : {};
        let result = new PagedViewModelOfIApiMediaWithCropsResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["total"] = this.total !== undefined ? this.total : <any>null;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPagedViewModelOfIApiMediaWithCropsResponse {
    total: number;
    items: IApiMediaWithCropsResponse[];
}

export abstract class IApiContentResponse implements IIApiContentResponse {
    cultures!: { [key: string]: IApiContentRoute; };

    constructor(data?: IIApiContentResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (_data["cultures"]) {
                this.cultures = {} as any;
                for (let key in _data["cultures"]) {
                    if (_data["cultures"].hasOwnProperty(key))
                        (<any>this.cultures)![key] = _data["cultures"][key] ? IApiContentRoute.fromJS(_data["cultures"][key]) : <any>null;
                }
            }
            else {
                this.cultures = <any>null;
            }
        }
    }

    static fromJS(data: any): IApiContentResponse {
        data = typeof data === 'object' ? data : {};
        throw new Error("The abstract class 'IApiContentResponse' cannot be instantiated.");
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.cultures) {
            data["cultures"] = {};
            for (let key in this.cultures) {
                if (this.cultures.hasOwnProperty(key))
                    (<any>data["cultures"])[key] = this.cultures[key] ? this.cultures[key].toJSON() : <any>null;
            }
        }
        return data;
    }
}

export interface IIApiContentResponse {
    cultures: { [key: string]: IApiContentRoute; };
}

export class PagedViewModelOfIApiContentResponse implements IPagedViewModelOfIApiContentResponse {
    total!: number;
    items!: IApiContentResponse[];

    constructor(data?: IPagedViewModelOfIApiContentResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.items = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.total = _data["total"] !== undefined ? _data["total"] : <any>null;
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(IApiContentResponse.fromJS(item));
            }
            else {
                this.items = <any>null;
            }
        }
    }

    static fromJS(data: any): PagedViewModelOfIApiContentResponse {
        data = typeof data === 'object' ? data : {};
        let result = new PagedViewModelOfIApiContentResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["total"] = this.total !== undefined ? this.total : <any>null;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPagedViewModelOfIApiContentResponse {
    total: number;
    items: IApiContentResponse[];
}

export class ApiException extends Error {
    message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isApiException = true;

    static isApiException(obj: any): obj is ApiException {
        return obj.isApiException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): any {
    if (result !== null && result !== undefined)
        throw result;
    else
        throw new ApiException(message, status, response, headers, null);
}